'use es6';

export const getSelectedFormItem = state => state.formSelection;
export const getSelectedFormItemType = state => getSelectedFormItem(state).formItemType;
export const getSelectedFormItemReference = state => getSelectedFormItem(state).formItemReference;